import Vue from 'vue'
import {
  Button,
  ButtonGroup,
  Form,
  FormItem,
  Input,
  Message,
  Container,
  Header,
  MessageBox,
  Aside,
  Main,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Row,
  Col,
  Calendar,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Pagination,
  DatePicker,
  Select,
  Option,
  OptionGroup,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Carousel,
  CarouselItem,
  transfer,
  Upload,
  Radio,
  Steps,
  Step,
  Switch,
  CheckboxGroup,
  Checkbox,
  Breadcrumb,
  BreadcrumbItem,
  Tree,
  InfiniteScroll,
  Tooltip,
  RadioGroup,
  Timeline,
  TimelineItem,
  Card,
  Avatar,
  Drawer,
  TimePicker,
  Popover,
  ColorPicker,
  Cascader,
  Badge,
} from 'element-ui'



// if (process.env.NODE_ENV == 'development') {
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.use(Badge)
Vue.use(Cascader)
Vue.use(ColorPicker)
Vue.use(TimePicker)
Vue.use(Popover)
Vue.use(Drawer)
Vue.use(Avatar)
Vue.use(Card)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(RadioGroup)
Vue.use(Tooltip)
Vue.use(InfiniteScroll)
Vue.use(Tree)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Main)
Vue.use(Menu)
Vue.use(MenuItemGroup)
Vue.use(Row)
Vue.use(Col)
Vue.use(Calendar)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(OptionGroup)
Vue.use(Option)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(transfer)
Vue.use(Upload)
Vue.use(Radio)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Switch)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
// }


import ZkTable from 'vue-table-with-tree-grid'
Vue.component('tree-table', ZkTable)
